import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useSelector } from 'react-redux';
import {
  getDismissedBoxBounds,
  getHighlightedQuadrant,
  isDismissedQuadrantVisible,
} from '../../state/ethereal/selectors';

const useStyles = makeStyles((theme) => ({
  dismissGrid: {
    position: 'absolute',
    padding: theme.spacing(2),
    background: theme.palette.shade.light,
  },
  dismissCard: {
    textAlign: 'center',
  },
  header: {
    padding: theme.spacing(1),
    background: theme.palette.shade.main,
    borderRadius: '4px 4px 0 0',
  },
  cardBorder: {
    borderRadius: theme.spacing(0.5),
  },
  cardBorderWithHighlight: {
    borderRadius: theme.spacing(0.5),
    boxShadow: `0 0 0 3px ${theme.palette.secondary.main}`,
  }
}));

const DismissQuadrant = (props) => {

  const classes = useStyles();

  let dismissTypes = [
    (props.civilCase ? 'Plaintiff' : 'Prosecution') + ' Peremptory (P)',
    'Defense Peremptory (D)',
    'For Cause (C)',
    'Hardship (H)'
  ];

  const highlightedQuadrant = useSelector(getHighlightedQuadrant);
  const open = useSelector(isDismissedQuadrantVisible);
  const bounds = useSelector(getDismissedBoxBounds);

  //TODO: This is hacky, we should fix this later
  let paperHeight = bounds.height - 35;
  let gridHeight = bounds.height;

  const dismissBoxes = dismissTypes.map((name, index) => {
    let oneClassName = classes.cardBorder;
    if (highlightedQuadrant === index + 1) {
      oneClassName = classes.cardBorderWithHighlight;
    }
    return (
      <Grid item xs={3} key={`dismiss-box-${index}`}>
        <Box
          className={oneClassName}
        >
          <Paper
            className={classes.dismissCard}
            style={{ height: paperHeight }}
          >
            <Box className={classes.header}>
              <b>{name}</b>
            </Box>
            <br />
            <br />
            Drag here to dismiss
          </Paper>
        </Box>
      </Grid>
    );
  });

  return (
    <div>
      <Paper style={{ visibility: open ? 'visible' : 'hidden' }}>
        <Grid
          container
          spacing={1}
          alignItems="center"
          style={{
            width: bounds.width,
            height: gridHeight,
            top: bounds.top + window.pageYOffset,
            left: bounds.left + window.pageXOffset,
          }}
          className={classes.dismissGrid}
        >
          {dismissBoxes}
        </Grid>
      </Paper>
    </div>
  );
};

export default DismissQuadrant;
